import { Alert } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import ReactMarkdown from "react-markdown";

export default function DomesticWireAdditionalInfo() {
  const { l10n } = useLocalization();
  const additionalInfo = l10n.getString("fedwire-additional-info");

  if (!additionalInfo) {
    return null;
  }

  return (
    <Alert kind="info" isDismissable={false} isActive={true}>
      <ReactMarkdown>{additionalInfo}</ReactMarkdown>
    </Alert>
  );
}
